import { render, staticRenderFns } from "./EditNote.vue?vue&type=template&id=50fe9d36&scoped=true"
import script from "./EditNote.vue?vue&type=script&lang=js"
export * from "./EditNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe9d36",
  null
  
)

export default component.exports